// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__34NL3","colMin":"styles_colMin__1yXFN","colCheckbox":"styles_colCheckbox__-4Uoz"};